import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";
import { AppTester } from "../../../../supporting";

export const useCreativeContexts = () => {

    const {
        isAKI,
        isAcademy,
    } = useAppTester();

    const {
        REACT_APP_URL_CREATIVE_CITY,
        REACT_APP_URL_AKI
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()
    const { pathname } = useLocation()

    const links = useMemo(() => ([
        {
            id: ContextCodes.creativeCity,
            active: isAcademy,
            content: 'creativecity.academy',
            linkTo: REACT_APP_URL_CREATIVE_CITY + suffix,
            action: () => {
                if (isAcademy) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_CREATIVE_CITY + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.aki,
            active: isAKI,
            content: 'креаторы москвы',
            linkTo: REACT_APP_URL_AKI + suffix,
            action: () => {
                if (isAKI) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_AKI + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [REACT_APP_URL_CREATIVE_CITY, REACT_APP_URL_AKI, history, suffix, pathname])

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: ''
        }
    }
}import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";
import { AppTester } from "../../../../supporting";

export const useCreativeContexts = () => {

    const {
        isAKI,
        isAcademy,
    } = useAppTester();

    const {
        REACT_APP_URL_CREATIVE_CITY,
        REACT_APP_URL_AKI
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()
    const { pathname } = useLocation()

    const links = useMemo(() => ([
        {
            id: ContextCodes.creativeCity,
            active: isAcademy,
            content: 'creativecity.academy',
            linkTo: REACT_APP_URL_CREATIVE_CITY + suffix,
            action: () => {
                if (isAcademy) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_CREATIVE_CITY + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.aki,
            active: isAKI,
            content: 'креаторы москвы',
            linkTo: REACT_APP_URL_AKI + suffix,
            action: () => {
                if (isAKI) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_AKI + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [REACT_APP_URL_CREATIVE_CITY, REACT_APP_URL_AKI, history, suffix, pathname])

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: ''
        }
    }
}